const QUIZTYPE = {
    DESCRIPTION: 1, // 記述式
    SELECT: 2,　　　// 選択式
    SORTING: 3,    // 並び替え
    NO_ANSWER: 4,   // 解答欄なし
    WRITTEN_RANDOM_ORDER: 5, // 順不問記述式
    MULTIPLE_CHOICE_RANDOM_ORDER: 6, // 順不問選択式
}

const QUIZTYPE_NAME = {
    1: "記述式",
    2: "選択式",
    3: "並び替え",
    4: "解答欄なし",
    5: "順不問記述式",
    6: "順不問選択式",
}

const GRADINGMETHOD = {
    MANUAL: 1,      // 手動
    AUTOMATIC: 2    // 自動
}

const LAYOUT = {
    HALF: 1,        // 幅50％
    FULL: 2,        // 幅100％
    MULTI: 3        // 複数行
}

// quizTypeが選択式の場合
const CHOICETYPE = {
    BUTTON: 1,
    SELECTBOX: 2
}

export {QUIZTYPE, GRADINGMETHOD, LAYOUT, CHOICETYPE, QUIZTYPE_NAME}
